import DotNetObject = DotNet.DotNetObject;
import { PartStatus } from '@crimsontide/core/client/interfaces';

export const PartStatusService = (() => {
  let dotNetObj: DotNetObject;
  let cachedPartStatuses: PartStatus[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getPartStatuses = async (useCache: boolean = true): Promise<PartStatus[]> => {
    if (useCache && cachedPartStatuses != null)
      return cachedPartStatuses;

    if (dotNetObj) {
      cachedPartStatuses = await dotNetObj.invokeMethodAsync<PartStatus[]>('GetAsync');
      return cachedPartStatuses;
    } else {
      throw 'Part Status DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getPartStatuses,
  };
})();
